import api from './api.js'

// 查询当前用户店铺信息
export function current(){
    return api.get('/resource-print/api/v1/store/current');
}

// 根据企业主键查询店铺信息
export function getShopSettledInfo(){
    return api.get('/resource-print/api/v1/shop/settled/getShopSettledInfo');
}

// 保存商家西悉尼
export function saveShopSettled(params){
    return api.post('/resource-print/api/v1/shop/settled',params);
}

// 保存卖家
export function saveSellerSettled(params){
    return api.post('/resource-print/api/v1/seller/settled',params);
}
// 根据企业主键查询卖家信息
export function getSellerSettledInfo(){
    return api.get('/resource-print/api/v1/seller/settled/getSellerSettledInfo');
}



// WEBPACK FOOTER //
// ./src/utils/shopStore.js